import { Routes } from '@angular/router';
import { RegisterComponent } from './purchase/register/register.component';
import { MainComponent } from './main/main.component';
import { CardComponent } from './user-area/card/card.component';
import { PaymentComponent } from './purchase/payment/payment.component';
import { LoginComponent } from './login/login/login.component';
import { LogoutComponent } from './login/logout/logout.component';
import { ExtendComponent } from './user-area/card/extend.component';
import { CodeConfirmationComponent } from './login/code-confirmation/code-confirmation.component';
import { RegulaminComponent } from './regulamin/regulamin.component';
import { StripeCheckoutComponent } from './purchase/stripe-checkout/stripe-checkout.component';

export const routes: Routes = [
  {path: '', component: MainComponent, pathMatch: 'full'},
  {path: 'register', component: RegisterComponent},
  {path: 'payment', component: PaymentComponent},
  {path: 'login', component: LoginComponent},
  {path: 'logout', component: LogoutComponent},
  {path: 'code-confirmation/:refCode/:code', component: CodeConfirmationComponent, pathMatch: 'prefix'},
  {
    path: 'checkout/success?session_id=:stripeCheckoutSessionId',
    component: StripeCheckoutComponent,
    pathMatch: 'prefix'
  },
  {path: 'card/:iccid', component: CardComponent, pathMatch: 'prefix'},
  {path: 'extend/:iccid/:code', component: ExtendComponent, pathMatch: 'prefix'},
  {path: 'regulamin', component: RegulaminComponent},
  {path: '**', component: MainComponent}
  // {path: '**', redirectTo: ''} // redirect to home page on any unknown route
];
